<template>
  <div class="wrapper">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item style="cursor:pointer;" @click.native="goback"
        >返回</el-breadcrumb-item
      >
      <el-breadcrumb-item>练习记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="header">
      <!-- <el-form class="form-style" :model="form" size="mini" :inline="true">
        <el-form-item label="试题类型">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option value="" label="全部"></el-option>
            <el-option value="1" label="单选题"></el-option>
            <el-option value="2" label="多选题"></el-option>
            <el-option value="3" label="判断题"></el-option>
            <el-option value="4" label="填空题"></el-option>
            <el-option value="5" label="简单题"></el-option>
            <el-option value="6" label="综合题"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="试题名称" prop="title">
          <el-input style="width: 200px" v-model="form.title" placeholder="请输入名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="search_btn" plain size="mini" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form> -->
    </div>

    <div class="questions">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          'font-size': '14px',
        }"
        stripe
        size="small"
      >
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="开始作答时间">
          <template slot-scope="scope">
            <span>{{ scope.row.start_time }}</span>
          </template>
        </el-table-column>

        <el-table-column label="练习时长">
          <template slot-scope="scope">
            <span v-if="scope.row.last_time > 0">{{
              formatTime(scope.row.last_time)
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="正确数">
          <template slot-scope="scope">
            <span v-if="scope.row.last_time > 0">{{
              scope.row.right_num
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="错误数">
          <template slot-scope="scope">
            <span v-if="scope.row.last_time > 0">{{
              scope.row.wrong_num
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column label="提交状态">
          <template slot-scope="scope">
            <span v-if="scope.row.last_time === 0">
              未提交
            </span>
            <span v-else>已提交</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="look(scope.row)"
              :disabled="!scope.row.start_time"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no" layout="total, prev, pager, next" :page-size="page_size" :total="total"></el-pagination>
    </div> -->
  </div>
</template>

<script>
import { getStuPracticeAndRecord } from '@/api/educational'

export default {
  name: 'question-book',
  data() {
    return {
      tableDataNew: [],
      tableDataOld: [],
      tableData: [],
      oldList: [],
      isRecordId: [],
      isRecord: '',
      questionlist: [],
      form: {
        type: '',
        question_title: '',
      },
      page_no: 1,
      page_size: 20,
      total: 0,
    }
  },
  mounted() {
    this.exam_id = this.$route.query.exam_id
    this.getStuPracticeAndRecord()
  },

  methods: {
    goback() {
      if (this.$route.query.state == 'offtime') {
        this.$router.replace({
          name: 'practice-offlist',
          query: {
            exam_id: this.exam_id,
          },
        })
      } else {
        this.$router.replace({
          name: 'practice-list',
          query: {
            exam_id: this.exam_id,
          },
        })
      }
    },

    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = seconds % 60

      return `${hours} 小时 ${minutes} 分钟 ${remainingSeconds} 秒`
    },

    look(row) {
      console.log(row)
      this.$router.push({
        name: 'practice-record',
        query: {
          title: row.title,
          exam_id: row.test_exam_id,
          examStuRecordId: row.id,
          isRecord: row.isRecord,
          stu_id: this.$store.state.user.userInfo.id,
          realname: this.$store.state.user.userInfo.stuUserInfo.realName,
        },
      })
    },
    search() {
      this.page_no = 1
      this.getStuPracticeAndRecord()
    },

    getStuPracticeAndRecord() {
      getStuPracticeAndRecord({
        examId: this.$route.query.exam_id,
      }).then((res) => {
        this.tableData = res.dataList

        console.log('查询学生练习记录')
        console.log(this.tableData)

        res.dataList.map((item) => {
          console.log(item.isRecord)
          this.isRecord = item.isRecord
          console.log(item.id, 88888)
        })
      })
    },

    handleCurrentChange(val) {
      this.page_no = val
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;

  background: white;
  border-radius: 5px;

  .header {
    margin-top: 20px;

    .search {
      width: 250px;
    }

    .search_btn {
      margin-left: 20px;
    }
  }

  .questions {
    .question_title {
      font-weight: bold;
      font-size: 16px;
    }

    .options {
      margin-top: 20px;
      float: left;
      width: 100%;

      .options_title {
        float: left;
      }

      .options_content {
        float: left;
      }
    }

    .answer {
      margin-top: 20px;
      float: left;
      width: 50%;

      .answer_label {
        font-weight: bold;
      }

      .answer_content {
        margin-left: 10px;
        color: green;
        font-weight: bold;
      }
    }

    .analysis {
      margin-top: 20px;
      float: left;
      width: 50%;

      .analysis_label {
        font-weight: bold;
      }

      .analysis_content {
      }
    }

    .question_btn {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}
</style>
